export default {
  computed: {
    language() {
      return this.$store.state.language.indexOf('en') !== -1
        ? 'en'
        : 'cn';
    },
  },
};
